var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"similarity-chip",class:_vm.chipClass},[_c('span',{staticClass:"mr-1"},[_vm._v("Similarity:")]),_c('span',[_vm._v(_vm._s(_vm.scorePct)+"%")])])}
var staticRenderFns = []

export { render, staticRenderFns }